import AbstractReelBehaviour from "./AbstractReelBehaviour";
import Reel from "../views/Reel";

class ReelVerticalSpinBehaviour extends AbstractReelBehaviour {
    constructor(reel: Reel, sortFunction: () => void)
    {
        super(reel, sortFunction);
    }
}

export default ReelVerticalSpinBehaviour;